// ============================================================
// KONSTANTA UNTUK MONITORING BANTUAN
// ============================================================

// Daftar Kecamatan di Sumbawa Barat
export const KECAMATAN = [
  'Taliwang',
  'Seteluk',
  'Poto Tano',
  'Brang Rea',
  'Brang Ene',
  'Jereweh',
  'Maluk',
  'Sekongkang'
];

// Data lengkap Kecamatan dan Desa/Kelurahan
export const kecamatanOptions = {
  "Taliwang": [
    "Menala",
    "Dalam",
    "Sampir",
    "Kuang",
    "Bugis",
    "Arab Kenangan",
    "Telaga Bertong",
    "Tamekan",
    "Seloto",
    "Lamunga",
    "Batu Putih",
    "Banjar",
    "Sermong",
    "Labuhan Kertasari",
    "Labuhan Lalar",
    "Lalar Liang"
  ],
  "Seteluk": [
    "Seteluk Tengah",
    "Seteluk Atas",
    "Seran",
    "Rempe",
    "Tapir",
    "Air Suning",
    "Kelanir",
    "Lamusung",
    "Desa Loka",
    "Meraran"
  ],
  "Poto Tano": [
    "Poto Tano",
    "Kokarlian",
    "Tambak Sari",
    "Tebo",
    "Senayan",
    "Kiantar",
    "Tuananga",
    "Mantar"
  ],
  "Brang Rea": [
    "Lamuntet",
    "Rarak Ronges",
    "Bangkat Monteh",
    "Moteng",
    "Tepas Sepakat",
    "Tepas",
    "Sapugara Bree",
    "Seminar Salit",
    "Desa Beru"
  ],
  "Brang Ene": [
    "Lampok",
    "Mujahidin",
    "Kalimantong",
    "Manemeng",
    "Mataiyang",
    "Mura"
  ],
  "Jereweh": [
    "Dasan Anyar",
    "Goa",
    "Beru",
    "Belo"
  ],
  "Maluk": [
    "Benete",
    "Bukit Damai",
    "Mantun",
    "Pasir Putih",
    "Maluk"
  ],
  "Sekongkang": [
    "Talonang Baru",
    "Tatar",
    "Ai Kangkung",
    "Sekongkang Atas",
    "Tongo",
    "Kemuning",
    "Sekongkang Bawah"
  ]
};

// Generate flat list of all desa/kelurahan untuk dropdown
export const DESA_KELURAHAN = Object.values(kecamatanOptions).flat();

// Status Proses
export const STATUS_PROSES = ['Usulan Diterima', 'Dalam Proses', 'Selesai'];

// Jenis Bantuan
export const JENIS_BANTUAN = [
  // 'DanaBantuanRombak',
  // 'Material',
  // 'Pembangunan',
  // 'RombakTotal',
  // 'Rumah Layak Huni',
  'Rumah Tidak Layak Huni',
  'Rehab Rumah Tidak Layak Huni',
  // 'Pembangunan Rumah Layak Huni'
];

// Fungsi helper untuk mendapatkan desa/kelurahan berdasarkan kecamatan
export const getDesaByKecamatan = (kecamatan) => {
  return kecamatanOptions[kecamatan] || [];
};

// Fungsi helper untuk validasi kecamatan
export const isValidKecamatan = (kecamatan) => {
  return KECAMATAN.includes(kecamatan);
};

// Fungsi helper untuk validasi desa/kelurahan
export const isValidDesa = (desa) => {
  return DESA_KELURAHAN.includes(desa);
};

// Fungsi untuk mendapatkan label lengkap lokasi
export const getLokasiLabel = (kecamatan, desa) => {
  if (!kecamatan && !desa) return '-';
  if (kecamatan && desa) return `${desa}, ${kecamatan}`;
  if (kecamatan) return kecamatan;
  if (desa) return desa;
  return '-';
};